/* TODO: This lovely grid came from NextGen (https://bitbucket.org/haymarketautomotive/aphrodite-frontend/src/master/)
 * and has been cut down from the original to fit the minimal needs of DRIVE.
 * This will be made a shared component in Olympus and when this is done we should delete this and pull from there.
 */

// @flow
import React, { Component } from 'react';
// Helpers
import PropTypes from 'prop-types';
import { hayPropTypes } from 'Olympus';
import classNames from 'classnames';
// Style
import styles from '../Grid.scss';

/**
 *	Grid React presentational component.
 */
class Grid extends Component<*, *> {
  /**
   * Props implementation.
   */
  static propTypes = {
    isFluid: PropTypes.bool,
    className: PropTypes.string,
    children: hayPropTypes.notAllowChildrenOfTypes('Grid')
  };
  /**
   * defaultProps implementation.
   */
  static defaultProps = {
    isFluid: false
  };

  /**
   * Render
   * @return {ReactElement} markup
   */
  render() {
    const { children, isFluid, className } = this.props;

    if (!children) {
      return null;
    }

    const gridTypeClass = isFluid
      ? styles['container-fluid']
      : styles['container'];
    const gridClasses = classNames([className, gridTypeClass]);

    return <section className={gridClasses}>{children}</section>;
  }
}

export default Grid;



// WEBPACK FOOTER //
// ./src/components/Grid/Grid/index.js